<template>
    <div class="content">
        <div class="content">
            <div class="pagination-container">
                <!-- DESKTOP -->
                <div class="text-xs-center white" v-if="$isDesktopDevice">
                    <v-btn :disabled="isFirstPage" color="base" round flat @click="previewPage()">
                        <v-icon>first_page</v-icon>
                    </v-btn>
                    <v-btn v-for="(page, index) in totalPages" round flat dark :key="`btn-${index}`"
                        @click="getPerPage(page)" :class="isActive(page)">
                        <span>{{ page }}</span>
                    </v-btn>

                    <v-btn :disabled="isLastPage" color="base" round flat @click="nextPage()">
                        <v-icon>last_page</v-icon>
                    </v-btn>
                </div>

                <!-- TABLET -->
                <div class=" text-xs-center white" v-if="$isTabletDevice">
                    <v-spacer></v-spacer>
                    <v-btn :disabled="isFirstPage" color="base" round flat @click="previewPage()">
                        <v-icon>first_page</v-icon>
                    </v-btn>
                    <v-icon class="mr-1" v-for="(page, index) in totalPages" color="base" round flat dark
                        :key="`btn-${index}`" @click="getPerPage(page)">{{ isActiveIcon(page) }}</v-icon>

                    <v-btn :disabled="isLastPage" color="base" round flat @click="nextPage()">
                        <v-icon>last_page</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                </div>

                <!-- PHONE -->
                <div class="text-xs-center" v-if="$isPhoneDevice">
                    <v-spacer></v-spacer>
                    <v-btn :disabled="isFirstPage" color="base" round flat @click="previewPage()">
                        <v-icon>first_page</v-icon>
                    </v-btn>
                    <h4>Pagina {{ this.pages }} de {{ this.totalPages }}</h4>

                    <v-btn :disabled="isLastPage" color="base" round flat @click="nextPage()">
                        <v-icon>last_page</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>

                </div>
            </div>


            <!-- COMBOBOX -->
            <div class="combobox-container">
                <v-combobox type class="combobox" v-model="select" :items="items" color="base" chips
                    @change="getPerPageTotalCount(select)"></v-combobox>
            </div>


        </div>

    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            currentPages: this.currentPage,
            show: true,
            pages: 1,
            isFirstPage: false,
            isLastPage: false,
            select: 25,
            items: [
                25,
                50,
                100,
            ]

        }
    },
    props: {
        perPage: {
            type: Number,
            required: true
        },
        currentPage: {
            type: Number,
            // required: true
        },
        totalPages: {
            type: Number,
            required: true
        },
    },
    computed: {
        ...mapState({
            groups: state => state.parts.groups,
        })
    },
    methods: {
        getPerPage(page) {
            this.pages = page
            this.$emit("Update", page, this.select)
        },
        getPerPageTotalCount(select) {
            this.$emit("click", select)
        },
        previewPage() {
            if (this.pages > 1) {
                this.currentPages = this.pages
                this.currentPages--;
            }
            this.getPerPage(this.currentPages)
        },
        nextPage() {
            this.getIsLastPage();
            if (this.pages < this.totalPages)
                this.currentPages = this.pages
            this.currentPages++;
            this.getPerPage(this.currentPages)
        },
        isActive(page) {
            // texto active cuando se da click a la pagina 
            return page === this.currentPage ? 'orange subPrimary--Text' : 'base--text';
        },
        isActiveIcon(page) {
            // texto active cuando se da click a la pagina 
            return page === this.currentPage ? 'radio_button_checked' : 'radio_button_unchecked';
        },
        showContent() {
            return this.show == true ? this.show = false : this.show = true;
        },
        getIsLastPage() {
            return this.pages == this.totalPages ? this.isLastPage = true : this.isLastPage = false
        },
        getIsFirstPage() {
            return this.pages == 1 ? this.isFirstPage = true : this.isFirstPage = false
        }
    },
    created() {
        this.getIsLastPage();
        this.getIsFirstPage();
    },
    updated() {
        this.getIsLastPage();
        this.getIsFirstPage();
    }
}
</script>
<style>
.content {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    margin: 0 auto;
}

.combobox {
    width: 0px;
}

.pagination-container {
    margin: auto;
}

</style>